import React from 'react';
import {Checkbox} from "@mui/material";
import {Box} from "@mui/system";
import {AccordionContainer} from "../../../components/accordion/AccordionContainer";
import RecommendedSettingConfigs from "./RecommendedSettingConfigs";
import Grid2 from "@mui/material/Unstable_Grid2";
import {COLORS} from "../../../ui/Theme";

const persianTitles = {
    money_flow: "ورود پول حقیقی",
    buy_pressure: "قدرت خرید حقیقی",
    buy_value: "خرید درشت حقیقی",
    buy_ratio: "نسبت سفارش‌های خرید",
    sell_ratio: "نسبت سفارش‌های فروش",
    roi: "بازدهی سهام",
    value_change: "ارزش معاملات",
    call_value_change: "ارزش اختیارهای خرید",
    put_value_change: "ارزش اختیارهای فروش",
    option_price_spread: "اسپرد قیمتی",
    global: "بازار جهانی",
    domestic: "بازار داخلی",
};

const RecommendedSettingConfigCardMobile = ({data, isChecked, onCheckboxChange, onInputChange}) => {

    return (
        <Grid2 xs={12} sx={{display: "flex", alignItems: "flex-start", gap: "10px"}}>
            <Checkbox
                checked={isChecked}
                onChange={onCheckboxChange}
                sx={{
                    color: COLORS.GRAY,
                    marginTop: "10px",
                    padding: "0",
                    "&.Mui-checked": {
                        color: "#1976d2",
                    },
                }}
            />
            <AccordionContainer
                key={data.name}
                title={persianTitles[data.name]}
            >
                <>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <RecommendedSettingConfigs
                            data={data}
                            onInputChange={onInputChange}
                        />
                    </Box>
                </>
            </AccordionContainer>
        </Grid2>
    );
};

export default RecommendedSettingConfigCardMobile;